<template>
  <el-dialog
    :visible="visible"
    :title="title"
    :before-close="cancel"
    width="1160px"
    append-to-body
  >
    <div style="display: flex; margin: 10px">
      <span style="align-self:center; margin-right: 5px">{{ $t('CargoMsg.Cargo_Query') }}: </span>
      <el-input v-model="searchValue" :placeholder="$t('SeaExport.PleaseInputAKeyword')" style="width: 300px" />
    </div>
    <div class="grid">
      <cargo-ag-grid
        :column-defs="columnDefs"
        :grid-options="gridOptions"
        :row-data="filterData"
        :show-side-bar="false"
        style="height:100%;min-height: 400px;"
      />
    </div>
    <template slot="footer">
      <div style="display: flex;text-align: left;">
        <span class="blue">{{ $t('CargoMsg.Cargo_CurrentSelection') }}:</span>
        <div style="flex: 1;height: 28px;overflow-y: auto;text-align: left;word-break: break-word;margin-left: 5px">
          {{ displayName }}
        </div>
      </div>
      <div>
        <el-button type="primary" @click="onSave">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="onReset">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
        <el-button @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import lang from '@/lang'
export default {
  name: 'ChooseUserDialog',
  components: { CargoAgGrid },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    eventName: {
      type: String,
      default: () => ''
    },
    filterKeys: {
      type: Array,
      default: () => ['email', 'englishName', 'chineseName']
    },
    visible: { type: Boolean, default: () => false },
    title: {
      type: String,
      default: () => lang.t('CargoMsg.Cargo_SelectTheApprover')
    }
  },
  data() {
    return {
      rowData: [],
      isAll: false,
      dialogVisible: false,
      searchValue: '',
      selectedRows: null,
      selectedTempRows: null,
      displayName: '',
      gridOptions: {
        rowSelection: 'multiple',
        onSelectionChanged: (event) => {
          this.updateSelect()
        }
      },
      selectedData: null,
      selectedBak: '',
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          headerCheckboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_LoginName'),
          field: 'login',
          width: 240
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'chineseName',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'englishName',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_email'),
          field: 'email',
          width: 240
        }, {
          headerName: this.$t('CargoMsg.Cargo_Tel'),
          field: 'phone',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_Fax'),
          field: 'fax',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_ElectricitySupplierAccountOrNot'),
          field: 'externalUser',
          width: 140,
          valueGetter: function(params) {
            if (params.data.externalUser) {
              return '√'
            } else {
              return ''
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_TheCompanyToWhichTheAccountBelongs'),
          field: 'partnerUUIDStr',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UserCompany'),
          field: 'defaultOfficeId',
          width: 200,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UserDepartment'),
          field: 'defaultDepId',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
          }
        }]
    }
  },
  computed: {
    filterData() {
      const { searchValue, rowData } = this
      if (!searchValue.trim()) {
        return rowData
      } else {
        const filterKeys = this.filterKeys
        return rowData.filter(row => {
          for (let i = 0; i < filterKeys.length; i++) {
            const key = filterKeys[i]
            if (row[key] && row[key].toLowerCase().indexOf(searchValue.trim().toLowerCase()) !== -1) return true
          }
        })
      }
    }
  },
  watch: {
    filterData(newList) {
      this.reCheckGrid(newList)
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const userList = getCacheListByKey(basicCacheKeys.basic_data_User)
      this.rowData = userList
      if (this.value && this.value.length > 0) {
        const map = {}
        for (const item of this.value) {
          map[item] = true
        }
        this.gridCheck(userList, map, true)
      }
    },
    reCheckGrid(list) {
      if (this.selectedRows && this.selectedRows.length > 0) {
        const map = {}
        for (const item of this.selectedRows) {
          map[item.userId] = true
        }
        this.gridCheck(list, map, false)
      }
    },
    gridCheck(userList, map, resetDisplayName = false) {
      for (const user of userList) {
        if (map[user.userId]) {
          user.checked = true
        }
      }
      this.$nextTick(() => {
        this.gridOptions.api.forEachLeafNode((node) => {
          if (node.data['checked']) {
            node.setSelected(true)
            delete node.data.checked
          } else {
            node.setSelected(false)
          }
        })
        if (resetDisplayName) {
          this.selectedRows = this.gridOptions.api.getSelectedRows()
          this.displayName = this.displayNameLabel()
        }
      })
    },
    onSave() {
      const selectRows = this.selectedRows
      const userIds = selectRows && selectRows.length > 0 ? selectRows.map(item => { return item.userId }) : []
      this.$emit('change', userIds)
      // this.cancel()
    },
    onReset() {
      this.selectedBak = ' '
      this.selectedData = null
      this.searchValue = ''
      this.gridOptions.api.forEachLeafNode((node) => {
        node.setSelected(false)
      })
      this.displayName = ''
      this.gridOptions.api.clearFocusedCell()
    },
    cancel() {
      this.$emit('close')
    },
    displayNameLabel() {
      const selectRows = this.selectedRows
      const nameList = []
      for (const selectRow of selectRows) {
        nameList.push(selectRow.chineseName)
      }
      return nameList.join(',')
    },
    updateSelect() {
      // 缓存当前已选择的数据
      // 之前选中的数据
      const oldSelectRows = this.selectedRows
      // 保留不在数据源的部分
      const oldRows = oldSelectRows && oldSelectRows.length > 0 ? oldSelectRows.filter(item => {
        return !this.filterData.includes(item)
      }) : []
      const newSelectRows = this.gridOptions.api.getSelectedRows()
      this.selectedRows = oldRows.concat(newSelectRows)
      this.displayName = this.displayNameLabel()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/element-variables.scss";
.cargo-pop-select-input{
  .operation {
    display: flex;
    justify-content: space-between;
  }
  .grid {
    display: flex;
    height: 460px;
  }
  .el-dialog__footer{
    display: flex;
    text-align: left;
    .blue {
      color: $--color-primary
    }
  }
}

</style>
